import { FCW } from '../types.ts';
import { SentryProvider } from '@/analytics/SentryProvider';
import { AppConfigProvider } from '@/appConfig/AppConfigProvider.tsx';
import { EventConfigProvider } from '@/eventConfig/EventConfigProvider.tsx';
import { LayerProvider } from '@/layers/LayerProvider.tsx';
import { NavigationProvider } from '@/navigation/NavigationProvider.tsx';
import { SaveRegistrationProvider } from '@/saveRegistration/SaveRegistrationProvider.tsx';
import { OnlineHookProvider } from '@/onlineHooks/OnlineHookProvider.tsx';
import { EventVerification } from '@/eventConfig/EventVerification.tsx';
import { FormProvider } from '@/form/FormProvider.tsx';
import { StaffNotesProvider } from './sidePanel/StaffNotesProvider.tsx';
import { SendFeedbackProvider } from './sendFeedback/SendFeedbackProvider.tsx';
import { SearchAddressProvider } from '@/searchAddress/SearchAddressProvider.tsx';
import { LanguageProvider } from '@/eventConfig/LanguageContext.tsx';

export const Providers: FCW = ({ children }) => {
  return (
    <SentryProvider>
      <AppConfigProvider>
        <EventConfigProvider>
          <LanguageProvider>
            <LayerProvider>
              <NavigationProvider>
                <StaffNotesProvider>
                  <FormProvider>
                    <SaveRegistrationProvider>
                      <SendFeedbackProvider>
                        <SearchAddressProvider>
                          <OnlineHookProvider />
                          <EventVerification />

                          {children}
                        </SearchAddressProvider>
                      </SendFeedbackProvider>
                    </SaveRegistrationProvider>
                  </FormProvider>
                </StaffNotesProvider>
              </NavigationProvider>
            </LayerProvider>
          </LanguageProvider>
        </EventConfigProvider>
      </AppConfigProvider>
    </SentryProvider>
  );
};
